var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuth)?_c('div',{staticClass:"flex overflow-hidden bg-gray-100"},[_c('Sidebar'),_c('Main'),_vm._l((_vm.notifications),function(item,index){return _c('Notification',{key:index,attrs:{"item":item,"index":index}})})],2):_c('Login')}
var staticRenderFns = []

export { render, staticRenderFns }